import { render, staticRenderFns } from "./reviewList.vue?vue&type=template&id=6314e585&"
import script from "./reviewList.vue?vue&type=script&lang=js&"
export * from "./reviewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports